import { createSelector } from 'reselect';

const getCompanyAccesor = state => state.company;

export const companySelector = createSelector(getCompanyAccesor, company => company);
